(function () {
  var nav = document.querySelector('.nesw-topnav');
  if (!nav) return;
  var cartBtn = nav.querySelector('[data-nesw-top-cart]');
  if (cartBtn) {
    cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (typeof window.openCartDrawer === 'function') window.openCartDrawer();
      else window.location.href = '/cart';
    });
  }
  /* Wishlist count badge removed (per Jay). Scope this data-count sync
     strictly to a wishlist badge so it can never touch the CART count badge
     (which manages its own data-count via paintCartBadges). No wishlist badge
     exists now → this is a no-op, kept defensively. */
  var badge = nav.querySelector('.nesw-topnav__count[data-wishlist-count]');
  if (badge) {
    var sync = function () { badge.setAttribute('data-count', (badge.textContent || '0').trim()); };
    sync();
    new MutationObserver(sync).observe(badge, { childList: true, characterData: true, subtree: true });
  }

  /* Sidebar drawer wiring — open via hamburger, close via backdrop tap,
     close button, or Escape. Body scroll lock so the underlying page
     doesn't pan while the drawer is open. */
  var sidebar = document.getElementById('nesw-sidebar');
  var backdrop = document.querySelector('.nesw-sidebar-backdrop');
  if (!sidebar || !backdrop) return;
  var hamburger = nav.querySelector('[data-nesw-sidebar-open]');
  var closeEls = document.querySelectorAll('[data-nesw-sidebar-close]');

  function openSidebar() {
    sidebar.hidden = false;
    /* Force a frame so the browser registers the from-state before the
       transform changes, otherwise the slide skips and snaps open. */
    requestAnimationFrame(function () {
      sidebar.classList.add('is-open');
      backdrop.classList.add('is-open');
    });
    document.body.classList.add('has-nesw-sidebar-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'true');
  }
  function closeSidebar() {
    sidebar.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    document.body.classList.remove('has-nesw-sidebar-open');
    if (hamburger) hamburger.setAttribute('aria-expanded', 'false');
    /* Wait for the slide-out transition to complete before hiding so the
       drawer doesn't pop offscreen mid-animation. */
    setTimeout(function () {
      if (!sidebar.classList.contains('is-open')) sidebar.hidden = true;
    }, 320);
  }

  if (hamburger) hamburger.addEventListener('click', openSidebar);
  closeEls.forEach(function (el) { el.addEventListener('click', closeSidebar); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeSidebar();
  });
})();
